export default "__VITE_ASSET__DwFSNiye__"